import {mapUserDbToType, User} from '@cp/model';
import {getDoc} from 'firebase/firestore';
import getUserDocRef from './getUserDocRef';

export default async function getUserDoc(uid: string): Promise<User | undefined> {
  const ref = getUserDocRef(uid);
  const snapshot = await getDoc(ref);
  return mapUserDbToType(snapshot);
}
